const AIDesk = {
  "结束会话": "Tamatkan Sesi",
  "转人工服务": "Alihkan ke Perkhidmatan Manusia",
  "跳转": "Pergi ke",
  "立即填写": "Isi Sekarang",
  "已提交": "Telah Dihantar",
  "提交": "Hantar",
  "查看内容": "Lihat Kandungan",
  "请填写必填项": "Sila isi ruangan yang wajib",
  "请输入内容":"Sila masukkan kandungan",
  "如果满意请给好评哦～":"Jika anda berpuas hati, sila berikan ulasan yang baik~",
  "请对本次服务进行评价": "Sila beri penilaian untuk perkhidmatan ini",
  "提交评价": "Hantar Penilaian",
  "服务评价": "Penilaian Perkhidmatan",
  "并发限制": "Terdapat terlalu ramai pengguna pada masa ini. Sila cuba lagi nanti",
  "分支选项异常": "Kandungan tidak normal, sila semak konfigurasi aliran tugas",
  "满意": "Berpuas hati",
  "不满意": "Tidak berpuas hati",
  "感谢您的反馈，我们会持续优化改进": "Terima kasih atas maklum balas anda, kami akan terus memperbaiki",
  "您遇到了哪方面的问题": "Masalah apa yang anda hadapi",
  "其他反馈内容": "Maklum balas lain",
  "取消": "Batal",
  "答非所问": "Jawapan tidak berkaitan",
  "未匹配相关内容": "Tiada kandungan yang sepadan",
  "信息错误": "Maklumat salah",
  "上下文理解错误": "Kesilapan pemahaman konteks",
  "格式不规范": "Format tidak standard",
  "内容不完整": "Kandungan tidak lengkap",
  "file 大小超过 100MB，无法发送": "Saiz fail melebihi 100MB, tidak boleh dihantar",
  "image 大小超过 20MB，无法发送": "Tidak dapat menghantar gambar kerana melebihi 20 MB",
  "video 大小超过 100MB，无法发送": "Tidak dapat menghantar video kerana melebihi 100 MB",
  "提交成功": "Berjaya dihantar",
  "userID 只能包含可打印 ASCII 字符": "UserID hanya boleh mengandung aksara ASCII yang boleh dicetak",
  "userID 不能包含'administrator'": "UserID tidak boleh mengandung 'administrator'",
  "userID 长度不能超过45字节": "Panjang UserID tidak boleh melebihi 45 bait",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "Kami menghargai maklum balas anda. Sila kongsi sebarang cadangan untuk membantu kami menambah baik.",
  "排队等待中": "Sedang beratur",
  "排队等待话术": "Maaf, semua wakil khidmat pelanggan kami sedang sibuk. Sila tunggu sebentar, kami akan membantu anda tidak lama lagi. Terima kasih atas pemahaman anda.",
  "当前前方排队人数": "Bilangan orang di hadapan dalam barisan sekarang",
  "结束排队": "Tinggalkan barisan",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "Ulasan yang dihantar lebih dari 3 minit tidak boleh diubah.",
  "不能发送空白消息": "Tidak dapat menghantar mesej kosong",
  "确认转人工": "Sahkan pindah kepada ejen",
}
export default AIDesk;
